import { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import Sidebar from "./sidebar";
import MessageContent from "./content";
import Loading from "components/Loading";
import { getListConversations } from "actions/conversationActions";
import { loadSetting } from "actions/userSetiting";
import useCallApi from "hook/useCallApi";
import useWindowSize from "hook/useWindowSize";
import ModalSetting from "./modalSetting";

const MessageV2 = ({ getListConversations, loadSetting }) => {
    const [conversation, setConversation] = useState(null);
    const [openSetting, setOpenSetting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState({});
    const [settings, setSettings] = useState({});
    const searchOptions = useMemo(() => [1, 10, "", filter], [filter]);
    const { reload: reloadConversation, loading: loadingCall } = useCallApi(getListConversations, searchOptions);
    const { data: settingData } = useCallApi(loadSetting, useMemo(() => ({}), []));
    const [heightBody, setHeightBody] = useState("100%");
    const { height: windowH } = useWindowSize();

    useEffect(() => {
        const { y } = document.getElementById("kt_content_container")?.getBoundingClientRect();
        const { height: footerHeight } = document.getElementById("kt_footer")?.getBoundingClientRect();
        setHeightBody(`calc(100vh - ${y + footerHeight}px)`);
    }, [windowH]);

    useEffect(() => {
        setSettings(settingData?.data || {})
    }, [settingData])

    useEffect(() => {
        setLoading(loadingCall);
    }, [loadingCall]);

    const handleSetting = (e) => {
        let value = e.target.value;
        if (e.target.type) value = e.target.checked;
        setSettings((prev) => ({ ...prev, [e.target.name]: value }));
    };

    return (
        <div className="d-flex flex-column flex-lg-row h-100" id="message-main" style={{ maxHeight: heightBody }}>
            <Loading isLoading={loading} />
            <Sidebar
                onConversationSelect={setConversation}
                setFilter={setFilter}
                filter={filter}
                onOpenSetting={() => setOpenSetting(true)}
            />
            <MessageContent
                conversation={conversation}
                setLoading={setLoading}
                settings={settings}
            />
            <ModalSetting
                isOpen={openSetting}
                onToggle={() => setOpenSetting(!openSetting)}
                settings={settings}
                onFormChange={handleSetting}
            />
        </div>
    );
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
    getListConversations,
    loadSetting,
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageV2);
